"use client";

import PrimaryBtn from "@/components/PrimaryBtn";
import { Icons } from "@assets/assets";
import { useTheme } from "@/HomeFeatures/Context/ThemeContext";
import { useScrollToContact } from "@/lib/ScrollUtils";

interface ButtonProps {
  buttonText?: string;
}

export function TechnologyButton({ buttonText }: ButtonProps) {
  const { handleOpenQuote } = useTheme();
  return (
    <PrimaryBtn
      text={buttonText || "Let's Talk With Us"}
      iconSrc={Icons?.chevronBlue}
      dark={true}
      onClick={() => {
        handleOpenQuote();
      }}
    />
  );
}

export function CtaButton1() {
  return (
    <PrimaryBtn
      text="Schedule a free strategy call"
      iconSrc={Icons?.chevron}
      dark={false}
      href={`${process.env.NEXT_PUBLIC_BASE_URL}/contact-us`}
    />
  );
}

export function EmergingTechButton() {
  const handleSmoothScroll = useScrollToContact();
  return (
    <PrimaryBtn
      text="Let's Talk with us"
      dark={true}
      iconSrc={Icons?.chevronBlue}
      onClick={() => {
        handleSmoothScroll();
      }}
    />
  );
}

export function BenefitsButton({ buttonText }: ButtonProps) {
  return (
    <PrimaryBtn
      text={buttonText || "Let's Talk With Us"}
      iconSrc={Icons?.chevronBlue}
      dark={true}
      href={`${process.env.NEXT_PUBLIC_BASE_URL}/contact-us`}
    />
  );
}

export function CtaButton2() {
  const { handleOpenQuote } = useTheme();
  return (
    <PrimaryBtn
      text="Schedule a free strategy call"
      iconSrc={Icons?.chevron}
      dark={false}
      onClick={() => {
        handleOpenQuote();
      }}
    />
  );
}

export function WhyChooseButton() {
  const handleSmoothScroll = useScrollToContact();
  return (
    <PrimaryBtn
      text={"Let's Talk With Us"}
      dark={false}
      iconSrc={Icons?.chevronBlue}
      styleClass="mt-[20px] lg:mt-0"
      onClick={() => {
        handleSmoothScroll();
      }}
    />
  );
}

export function SuccessStoryButton() {
  const handleSmoothScroll = useScrollToContact();
  return (
    <PrimaryBtn
      text="Schedule a Meeting"
      iconSrc={Icons?.chevronBlue}
      dark={true}
      onClick={() => {
        handleSmoothScroll();
      }}
    />
  );
}

export function BannerButton({ buttonText }: { buttonText?: string }) {
  const { handleOpenQuote } = useTheme();
  return (
    <PrimaryBtn
      styleClass="mx-auto"
      text={buttonText || "Let's Discuss your Idea"}
      iconSrc={Icons?.chevronBlue}
      onClick={() => {
        handleOpenQuote();
      }}
    />
  );
}
